import type { SVGProps } from "react";
export interface GithubCircleIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function GithubCircleIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: GithubCircleIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M20.875 12a8.875 8.875 0 1 0-11.25 8.554l.364.092.112.032a1.126 1.126 0 0 1-.504 2.181l-.115-.02-.458-.117C4.325 21.42.875 17.115.875 12 .875 5.856 5.856.875 12.001.875c6.143 0 11.124 4.981 11.124 11.126 0 5.278-3.675 9.696-8.605 10.838l-.114.019a1.125 1.125 0 0 1-.394-2.212l.366-.092A8.88 8.88 0 0 0 20.875 12"
      />
      <path
        fill={color}
        d="M13.141 21.74v-2.515c0-.18-.037-.344-.11-.552l-.32-.812a1.378 1.378 0 0 1 1.278-1.886l.244-.012a2.397 2.397 0 0 0 2.143-2.39c0-.726-.157-1.387-.48-1.923l-.15-.22a1.44 1.44 0 0 1-.136-1.505l.064-.151a1.4 1.4 0 0 0 .073-.511q-.305.13-.556.378c-.164.161-.377.3-.638.375-.259.073-.5.064-.695.024-.728-.146-1.286-.266-1.856-.266-.285 0-.568.03-.869.078l-.987.188a1.457 1.457 0 0 1-1.203-.284l-.132-.115a1.8 1.8 0 0 0-.558-.378c-.01.233.038.458.14.662l.077.186c.127.38.089.797-.104 1.148l-.109.17c-.425.57-.63 1.314-.63 2.143a2.394 2.394 0 0 0 2.385 2.403c.92 0 1.554.87 1.335 1.718l-.056.168c-.28.702-.429 1.005-.429 1.364v2.515a1.126 1.126 0 0 1-2.25 0v-2.515c0-.412.085-.808.193-1.16a4.65 4.65 0 0 1-3.429-4.493c0-1.04.226-2.135.815-3.1-.33-.976-.209-2.006.227-2.88l.093-.157c.24-.35.639-.56 1.065-.56l.399.019c.778.077 1.5.383 2.1.866.574-.115 1.238-.236 1.927-.236.688 0 1.35.12 1.924.236a3.97 3.97 0 0 1 2.5-.885l.181.013c.356.05.679.247.885.547l.092.156.169.39c.292.783.34 1.657.058 2.492.589.964.815 2.059.815 3.1a4.65 4.65 0 0 1-3.43 4.49c.11.353.195.75.195 1.162v2.515a1.126 1.126 0 0 1-2.25 0"
      />
    </svg>
  );
}
